// Mounts the UI shell (M7) into #ui: the palette's UI tokens become CSS custom properties on the document
// (the shell and the overlay layer read them; ui/shell.css), the shell context is set, and <App/> renders.
import { render } from 'preact';
import { paletteHex } from '../art/palette.ts';
import { App } from './App.tsx';
import { type ShellCtx, setShellCtx } from './ctx.ts';
import './shell.css';

/** CSS custom property names for the palette.json tokens the chrome uses (`ui.cream` → `--ui-cream`). */
export function cssTokens(hex: Readonly<Record<string, string>>): Record<string, string> {
  const out: Record<string, string> = {};
  for (const [k, v] of Object.entries(hex)) {
    if (!/^(ui|glow|tier|stall|state|machine|toy)\./.test(k)) continue;
    out[`--${k.replace('.', '-')}`] = v;
  }
  return out;
}

export function applyTokens(doc: Document, hex: Readonly<Record<string, string>>): void {
  const st = doc.documentElement.style;
  for (const [k, v] of Object.entries(cssTokens(hex))) st.setProperty(k, v);
}

export function mountUi(root: HTMLElement, ctx: ShellCtx): () => void {
  setShellCtx(ctx);
  applyTokens(root.ownerDocument, paletteHex(ctx.data().palette.colors));
  render(<App />, root);
  return () => {
    render(null, root);
    setShellCtx(null);
  };
}
